import { Firebase } from "@/app/core/base/FirebaseApp";
import { toast } from "react-toastify";
import {
    getFirestore,
    collection,
    getDocs,
    updateDoc,
    doc,
    getDoc,
    Timestamp,
    getCountFromServer,
    query,
    where,
    addDoc,
    deleteDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../../util/helpers/ErrorHelper";
import { FireHelper } from "../../util/helpers/FireHelper";
import { DateHelper } from "../../util/helpers/DateHelper";
import algoliasearch from "algoliasearch";

export const ResponseController = {
    db: getFirestore(Firebase),

    ToFirestoreResponse: function (data) {
        let updatedData = {
            complainId: data.complainId,
            id: data.id,
            userId: data.userId,
            description: data.description,

            createdDate: data.createdDate ?? Timestamp.now(),
            updatedDate: Timestamp.now(),
        };
        return FireHelper.ToFirestoreDoc(updatedData);
    },

    Insert: async function (data) {
        try {
            const coll = collection(this.db, "response");
            const result = await addDoc(coll, this.ToFirestoreResponse(data));
            return result.id;
        } catch (e) {
            console.log("ResponseController insert error", e);
            toast.error(ErrorHelper.HandleMessage(e));
            return null;
        }
    },

    List: async function (complainId) {
        try {
            const responseCollection = collection(this.db, "response");
            const responseQuery = query(responseCollection, where("complainId", "==", complainId));
            const querySnapshot = await getDocs(responseQuery);
    
            if (querySnapshot.empty) {
                return [];
            }
    
            const results = querySnapshot.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }));
    
            return results;
        } catch (error) {
            return [];
        }
    },

    GetTotalCount: async function () {
        const coll = collection(this.db, "response");
        const snapshot = await getCountFromServer(coll);
        return snapshot.data().count;
    },


    Delete: async function (id) {
        await deleteDoc(doc(this.db, "response", id));
        return true;
    },
};
